/**
 * Zentrales Register aller globalen Tastenkürzel. Einzige Quelle für den
 * Spickzettel („?"), den Palette-Fuß und die kbd-Hinweise. Die eigentlichen
 * Handler leben weiterhin dort, wo sie wirken (App-Shell, Sidebar, Editor) —
 * hier stehen nur ihre Beschreibungen, damit Kürzel auffindbar & konsistent
 * bleiben. Neue globale Kürzel bitte hier eintragen.
 */
export interface ShortcutDef {
  /** Tasten in Anzeige-Reihenfolge, z. B. ['⌘', 'K'] oder ['?']. */
  keys: string[];
  label: string;
  group: string;
}

export const SHORTCUT_GROUPS = ['Allgemein', 'Navigation', 'Beleg-Editor'] as const;

export const SHORTCUTS: ShortcutDef[] = [
  { keys: ['⌘', 'K'], label: 'Suche & Befehle öffnen', group: 'Allgemein' },
  { keys: ['?'], label: 'Diese Kürzel-Übersicht anzeigen', group: 'Allgemein' },
  { keys: ['⌘', 'B'], label: 'Seitenleiste ein-/ausklappen', group: 'Navigation' },
  { keys: ['#'], label: 'In der Palette: nur Befehle statt Suche', group: 'Navigation' },
  { keys: ['↑', '↓'], label: 'In der Palette: Eintrag wählen', group: 'Navigation' },
  { keys: ['↵'], label: 'In der Palette: Auswahl öffnen/ausführen', group: 'Navigation' },
  { keys: ['esc'], label: 'Dialog/Palette schließen', group: 'Navigation' },
  { keys: ['⌘', 'S'], label: 'Beleg speichern', group: 'Beleg-Editor' },
  { keys: ['↵'], label: 'Nächste Position (im Positionsraster)', group: 'Beleg-Editor' },
  { keys: ['↵'], label: 'In der Artikel-Spalte: Artikel-Suche öffnen', group: 'Beleg-Editor' },
  { keys: ['Bild ↑', 'Bild ↓'], label: 'In der Artikel-Suche: Trefferliste blättern', group: 'Beleg-Editor' },
  { keys: ['⌥', '↑', '↓'], label: 'In der Artikel-Suche: Warengruppe wechseln', group: 'Beleg-Editor' },
  { keys: ['⇧', '↵'], label: 'Positionen in die Zwischenablage kopieren', group: 'Beleg-Editor' },
  { keys: ['⌘', 'V'], label: 'Positionen aus Excel einfügen', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', '↵'], label: 'Neue Position — Fokus direkt in die Artikelsuche', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', 'D'], label: 'Aktuelle Position duplizieren', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', 'X'], label: 'Aktuelle Position löschen', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', 'H'], label: 'Überschrift einfügen', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', 'B'], label: 'Seitenumbruch einfügen', group: 'Beleg-Editor' },
  { keys: ['⌘', '⇧', '↓'], label: 'Ins Positionsraster springen', group: 'Beleg-Editor' },
];

/** Kürzel nach Gruppe, in der Reihenfolge von `SHORTCUT_GROUPS`. */
export function shortcutsByGroup(): { group: string; items: ShortcutDef[] }[] {
  return SHORTCUT_GROUPS.map((group) => ({
    group,
    items: SHORTCUTS.filter((shortcut) => shortcut.group === group),
  })).filter((section) => section.items.length > 0);
}
